import React from 'react';
import { EventVenueState } from '../EventVenueDialog/useEventVenueDialog';
import { AccommodationPropertyWithCalculatedPrice } from '@shared/hooks/useSearchExtendedAccommodationProperties';
import { HotelCard } from './HotelCard';

interface HotelCardWithIntentProps {
  property: AccommodationPropertyWithCalculatedPrice;
  location: google.maps.LatLngLiteral;
  index: number;
  isLoading: boolean;
  activePinId?: string;
  eventVenueState: EventVenueState;
  onClickHotelPin: (id: string, location: google.maps.LatLngLiteral, show: boolean) => void;
}

export const HotelCardWithIntent: React.FC<HotelCardWithIntentProps> = React.memo(({ property, location, eventVenueState, activePinId, onClickHotelPin }) => {
  const intent = 'hotels' === eventVenueState ? 'aiBorder' : 'noBorder';
  return (
    <HotelCard
      property={property}
      location={location}
      intent={intent}
      activePinId={activePinId}
      onClickHotelPin={onClickHotelPin}
    />
  );
});
